import Template from '../../component/Template.js';
import Api from '../../component/Api';
import { useState } from 'react';
import React, {useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/*


*/


export default function AddRole() {// CHECKING IF USER IS VALID
  const isAuth = useAuth();
  const navigate = useNavigate();
  if (isAuth === false) {
    navigate("/admin/")
  }


  const [roleTitle, setRoleTitle] = useState("");
  const [message, setMessage] = useState("");
  const [iscreaterole, setCreateRole] = useState(false);//13/3/2024

  const { http } = Api();
 
  //role validation
  useEffect(() => {
    const access = async () => {

        const id = localStorage.getItem("id");
        try {
            const response = await http.get('/Admin/get-all-user-permissions', { params: { user_id: id } });

            const permissions = response.data;
            permissions.forEach(permission => {

                if (permission.name === "create-role") {
                  setCreateRole(true);
                }


                
            });
        } catch (error) {
          setCreateRole(false);
          
        }
    };
    access();
}, []);



  const validateForm = () => {

    if (!roleTitle) {

      setMessage("Please enter a Role Title");
      document.getElementById('roletitle').focus();
      return false;
    }
    return true;
  };

  const cancelForm = () => {
    navigate("/admin/roles");
  };


  const saveNewRole = (event) => {
    event.preventDefault();
    if (validateForm()) {
        const endpointaddrole = `/Admin/create-role/${roleTitle}`;

    http.put(endpointaddrole)
        .then(response => {
            if (response.data.status_code === 'MSG7') {

            setMessage("Role Created Successfully");
            sessionStorage.setItem("message", "Role Created Successfully");
            navigate("/admin/roles");


            }
        })
        .catch(error => {
            console.error(error);
            
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                const errorMessage = error.response.data.message; // Extract error message from response
                toast.error(errorMessage);
            } else if (error.request) {
                // The request was made but no response was received
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
        });
    }

};



  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">                
                <div className="col-md-12">
                  <div className="card-header"> 
                    <div className="py-3 d-flex justify-content-between align-items-center ">
                      <h5>Add Role</h5>
                    </div>
                  </div>
                  <div className="card-body">
                  {message && (
                                                <div className="alert alert-danger mar2" role="alert">
                                                    <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                                                </div>
                                            )}
                    <div className="card-body pdg">
                      <div className="table-responsive">

                      {iscreaterole && (
                        <form className="form theme-form">
                          <div className="card-body custom-input">
                          
                            <div className="row">
                              <div className="col">
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Role Title</label>
                                  <div className="col-sm-9">
                                    <input className="form-control input-air-primary" type="text" id="roletitle" name="roletitle" onChange={(e) => setRoleTitle(e.target.value)} placeholder="Role Titile" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                            <div className="col-md-12 txt-aln">
                              <button className="btn btn-primary me-3" type="submit" onClick={saveNewRole}>Submit</button>
                              <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                            </div>
                          
                        </form>
                      )}



                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Template>
    </>
  );
}
